import React from "react";
import SbEditable from "storyblok-react";
import { blokType } from "../../types";

import { CarouselCmp, CarouselProps } from "./Carousel";

interface CarouselWBlokProps {
  blok: CarouselProps & blokType;
}

const Carousel: React.FC<CarouselWBlokProps> = ({
  blok,
}) => {
  return (
    <SbEditable content={blok}>
      <CarouselCmp
        slides_per_view_mobile={blok.slides_per_view_mobile}
        slides_per_view_tablet={blok.slides_per_view_tablet}
        slides_per_view_desktop={blok.slides_per_view_desktop}
        slides_per_view_wide={blok.slides_per_view_wide}
        slides={blok.slides}
      ></CarouselCmp>
    </SbEditable>
  );
};

export default Carousel 